var React = require('react');

var ContextContentMixin = require('./../context_content_mixin');
var CustomStylesMixin = require('./../custom_styles_mixin');
var RevealMixin = require('../reveal_mixin');

var createReactClass = require('create-react-class');
module.exports = createReactClass({

  displayName: 'BackgroundMaintenance',

  mixins : [ContextContentMixin, CustomStylesMixin, RevealMixin],

  render : function () {
    return (
      <div className="content-container" style={this.shadow()}>
        <div className="head-line" style={this.secondary_text_color()}>
          Maintenance
        </div>
        <div className="subheader" style={this.primary_text_color()}>
          We're undergoing a bit of scheduled maintenance.
        </div>
        <div className="hr"></div>
        <div className="clearfix"></div>
        <div className="context" style={this.secondary_text_color()}>
          { this.contextContent() }
        </div>
        <div className="buttons-container single-button" style={this.has_status_page()}>
          <a href={this.href(this.props.status_page_url)} style={this.mergeStyles(this.button(), this.has_status_page())} target="_blank">
            <span className="fa fa-power-off"></span>
            View Statuspage
          </a>
        </div>
      </div>
    )
  }
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/templates/background/maintenance.jsx